import { NgModule } from '@angular/core';
import { NavigationModule } from '@fundament/navigation/navigation.module';
import { ActionsModule } from '@fundament/actions/actions.module';
import { StoreModule } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { IntroductionMessageComponent } from './introduction-message/introduction-message.component';
import { FEATURE_KEY } from './feature-key';
import { introductionReducer } from './introduction.reducer';

@NgModule({
  imports: [
    ActionsModule,
    CommonModule,
    NavigationModule,
    StoreModule.forFeature(FEATURE_KEY, introductionReducer),
  ],
  declarations: [IntroductionMessageComponent],
  exports: [IntroductionMessageComponent],
})
export class IntroductionModule {}
